import dynamic from 'next/dynamic';
import type { SVGProps } from 'react';

const Account = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/Account')
);
const Add = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/Add')
);
const Appointments = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/Appointments')
);
const ArrowLeft = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/ArrowLeft')
);
const ArrowRight = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/ArrowRight')
);
const Billing = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/Billing')
);
const Cart = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/Cart')
);
const Call = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/Call')
);
const Check = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/Check')
);
const Clock = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/Clock')
);
const CheckFilled = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/CheckFilled')
);
const Chat = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/Chat')
);
const Chevron = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/Chevron')
);
const ChevronDown = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/ChevronDown')
);
const ChevronLeft = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/ChevronLeft')
);
const ChevronRight = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/ChevronRight')
);
const ChevronUp = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/ChevronUp')
);
const Close = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/Close')
);
const CurrencyDollar = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/Dollar')
);
const Email = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/Email')
);
const EmptyCircle = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/EmptyCircle')
);
const ExternalLink = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/ExternalLink')
);
const Facebook = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/Facebook')
);
const Headphones = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/Headphones')
);
const Help = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/Help')
);
const Impact = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/Impact')
);
const Instagram = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/Instagram')
);
const Lightning = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/Lightning')
);
const LinkedIn = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/LinkedIn')
);
const PauseSquare = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/PauseSquare')
);
const Pin = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/Pin')
);
const Play = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/Play')
);
const PlaySquare = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/PlaySquare')
);
const Plus = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/Plus')
);
const PlusFilled = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/PlusFilled')
);
const PrivacyOptions = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/PrivacyOptions')
);
const Referrals = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/Referrals')
);
const Refresh = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/Refresh')
);
const Sun = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/Sun')
);
const Subtract = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/Subtract')
);
const Twitter = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/Twitter')
);
const TrashCan = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/TrashCan')
);
const Warning = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/Warning')
);
const Wrench = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/Wrench')
);
const Monitoring = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/Monitoring')
);
const Year = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/Year')
);
const Maintenance = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/Maintenance')
);
const Transfer = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/Transfer')
);
const EnergyProduction = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/EnergyProduction')
);
const FullService = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/FullService')
);
const Battery = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/Battery')
);
const Star = dynamic(
  () => import('../../public/cmsAssets/assets/img/icons/Star')
);

export interface IconSvgProps extends SVGProps<SVGSVGElement> {
  name: string;
  color?: string;
  width?: number;
  classname?: string;
  backgroundColor?: string;
  innerColor?: string;
  viewBox?: string;
  height?: number;
}

export enum IconName {
  DOLLAR = 'Dollar',
  WRENCH = 'Wrench',
  PLUS = 'Plus',
  PLUS_FILLED = 'plusFilled',
  CHEVRON = 'Chevron',

  // Base Library Icons
  SUN_LINE = 'SunLine',
  LIGHTNING = 'Lightning',
  CHECK = 'Check',
  CHECK_FILLED = 'CheckFilled',
  ARROW_LEFT = 'ArrowLeft',
  ARROW_RIGHT = 'ArrowRight',
  ADD = 'Add',
  CLOSE = 'Close',
  CHAT = 'Chat',
  CHEVRON_RIGHT = 'ChevronRight',
  CHEVRON_LEFT = 'ChevronLeft',
  CHEVRON_UP = 'ChevronUp',
  CHEVRON_DOWN = 'ChevronDown',
  CART = 'Cart',
  CALL = 'Call',
  CLOCK = 'Clock',
  ACCOUNT = 'Account',
  REFERRALS = 'Referrals',
  REFRESH = 'Refresh',
  IMPACT = 'Impact',
  APPOINTMENTS = 'Appointments',
  EMAIL = 'Email',
  WARNING = 'Warning',
  BILLING = 'Billing',
  HEADPHONES = 'Headphones',
  FACEBOOK = 'Facebook',
  TWITTER = 'Twitter',
  LINKEDIN = 'LinkedIn',
  INSTAGRAM = 'Instagram',
  EXTERNAL_LINK = 'ExternalLink',
  PAUSE_SQUARE = 'PauseSquare',
  PIN = 'Pin',
  PLAY = 'Play',
  PLAY_SQUARE = 'PlaySquare',
  SUBTRACT = 'Subtract',
  EMPTY_CIRCLE = 'EmptyCircle',
  PRIVACY_OPTIONS = 'PrivacyOptions',
  HELP = 'Help',
  MONITORING = 'Monitoring',
  YEAR = 'Year',
  MAINTENANCE = 'Maintenance',
  TRANSFER = 'Transfer',
  TRASH_CAN = 'TrashCan',
  ENERGY_PRODUCTION = 'EnergyProduction',
  FULL_SERVICE = 'FullService',
  BATTERY = 'Battery',
  STAR = 'Star',
}

function Icon(props: IconSvgProps) {
  const { name } = props;
  switch (name) {
    case IconName.DOLLAR:
      return <CurrencyDollar {...props} />;
    case IconName.WRENCH:
      return <Wrench {...props} />;
    case IconName.CHEVRON:
      return <Chevron {...props} />;
    case IconName.HEADPHONES:
      return <Headphones {...props} />;
    case IconName.SUN_LINE:
      return <Sun {...props} />;

    // Base Library Icons
    //
    // Copy from base library and replace the <svg> tag with <BaseLibraryIconSvg/>
    // and change any fill colors to 'currentColor' to automatically pass in correct styles
    case IconName.PLUS:
      return <Plus {...props} />;
    case IconName.PLUS_FILLED:
      return <PlusFilled {...props} />;
    case IconName.CHECK:
      return <Check {...props} />;
    case IconName.CLOCK:
      return <Clock {...props} />;
    case IconName.CHECK_FILLED:
      return <CheckFilled {...props} />;
    case IconName.LIGHTNING:
      return <Lightning {...props} />;
    case IconName.ARROW_LEFT:
      return <ArrowLeft {...props} />;
    case IconName.ARROW_RIGHT:
      return <ArrowRight {...props} />;
    case IconName.ADD:
      return <Add {...props} />;
    case IconName.SUBTRACT:
      return <Subtract {...props} />;
    case IconName.CLOSE:
      return <Close {...props} />;
    case IconName.CHAT:
      return <Chat {...props} />;
    case IconName.CHEVRON_RIGHT:
      return <ChevronRight {...props} />;
    case IconName.CHEVRON_LEFT:
      return <ChevronLeft {...props} />;
    case IconName.CHEVRON_UP:
      return <ChevronUp {...props} />;
    case IconName.CHEVRON_DOWN:
      return <ChevronDown {...props} />;
    case IconName.CART:
      return <Cart {...props} />;
    case IconName.CALL:
      return <Call {...props} />;
    case IconName.ACCOUNT:
      return <Account {...props} />;
    case IconName.REFERRALS:
      return <Referrals {...props} />;
    case IconName.REFRESH:
      return <Refresh {...props} />;
    case IconName.IMPACT:
      return <Impact {...props} />;
    case IconName.EMAIL:
      return <Email {...props} />;
    case IconName.APPOINTMENTS:
      return <Appointments {...props} />;
    case IconName.WARNING:
      return <Warning {...props} />;
    case IconName.BILLING:
      return <Billing {...props} />;
    case IconName.FACEBOOK:
      return <Facebook {...props} />;
    case IconName.INSTAGRAM:
      return <Instagram {...props} />;
    case IconName.LINKEDIN:
      return <LinkedIn {...props} />;
    case IconName.TWITTER:
      return <Twitter {...props} />;
    case IconName.EXTERNAL_LINK:
      return <ExternalLink {...props} />;
    case IconName.EMPTY_CIRCLE:
      return <EmptyCircle {...props} />;
    case IconName.PIN:
      return <Pin {...props} />;
    case IconName.PLAY:
      return <Play {...props} />;
    case IconName.PRIVACY_OPTIONS:
      return <PrivacyOptions />;
    case IconName.HELP:
      return <Help {...props} />;
    case IconName.PAUSE_SQUARE:
      return <PauseSquare {...props} />;
    case IconName.PLAY_SQUARE:
      return <PlaySquare {...props} />;
    case IconName.MONITORING:
      return <Monitoring {...props} />;
    case IconName.YEAR:
      return <Year {...props} />;
    case IconName.MAINTENANCE:
      return <Maintenance {...props} />;
    case IconName.TRANSFER:
      return <Transfer {...props} />;
    case IconName.TRASH_CAN:
      return <TrashCan {...props} />;
    case IconName.ENERGY_PRODUCTION:
      return <EnergyProduction {...props} />;
    case IconName.FULL_SERVICE:
      return <FullService {...props} />;
    case IconName.BATTERY:
      return <Battery {...props} />;
    case IconName.STAR:
      return <Star {...props} />;
    // Return null for unsupported icon names
    default:
      return null;
  }
}
export default Icon;
